import React from 'react';

const ChaptersSection = () => {
  const chapters = [
    {
      number: 'Chapter 1',
      title: 'Permaculture Thinking',
      description: "Apply nature's design principles to your finances. Build systems that sustain themselves — less effort, more output."
    },
    {
      number: 'Chapter 2',
      title: 'DIY Systems',
      description: 'Rocket stove builds, basic solar setups, rainwater collection. Practical projects that pay for themselves fast.'
    },
    {
      number: 'Chapter 3',
      title: 'Smarter Spending',
      description: 'The Audit-Eliminate-Replace-Optimize framework. Find invisible expenses and redirect money to what matters.'
    },
    {
      number: 'Chapter 4',
      title: 'Food Strategies',
      description: 'Cut your grocery bill without eating worse. Batch cooking, discount-first shopping, and a $50/week framework.'
    },
    {
      number: 'Chapter 5',
      title: 'Energy Independence',
      description: 'Reduce your power bill without spending thousands. Simple changes and weekend projects that compound over time.'
    },
    {
      number: 'Chapter 6',
      title: 'Intentional Living',
      description: "Free leisure, community sharing, skill-building over spending. Design a life that's rich without being expensive."
    },
    {
      number: 'Chapter 7',
      title: 'Implementation Plan',
      description: 'Your week-by-week action plan. Start seeing results in 7 days. Full transformation in 90.'
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-[#2C1810] mb-4 text-center">
          7 Chapters. One Complete System.
        </h2>
        <p className="text-[#5A5046] text-lg text-center mb-16">
          Each chapter stands alone. Together, they transform how you live and spend.
        </p>
        
        <div className="grid md:grid-cols-2 gap-8">
          {chapters.map((chapter, index) => (
            <div key={index} className="space-y-3">
              <p className="text-sm text-[#6B7A5C] uppercase tracking-wider font-semibold">
                {chapter.number}
              </p>
              <h3 className="text-2xl font-bold text-[#2C1810]">
                {chapter.title}
              </h3>
              <p className="text-[#5A5046] leading-relaxed">
                {chapter.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChaptersSection;